var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-subscription" }, [
    _c("h4", [_vm._v(_vm._s(_vm.heading))]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(" We are becoming SoftwareOne please visit "),
      _c("a", { attrs: { href: "https://www.softwareone.com" } }, [
        _vm._v("SoftwareOne"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }